import api from '@/utils/api/api'

type RequestOptions = {
  signal?: AbortSignal
}

export type ExistingOrganisation = {
  id: string
  code: number
  description: string
  fullLegalName: string
  shortLegalName: string
  isLegal: boolean
}

export type VatUniquenessResponse = {
  isUnique: boolean
  existingOrganisation?: ExistingOrganisation
}

export const organisationsApi = {
  checkVatUniqueness: async (vatNumber: string, options?: RequestOptions) => {
    const { data } = await api.get<VatUniquenessResponse>(
      `/organisations/unique/vat/${vatNumber}`,
      { signal: options?.signal }
    )
    return data
  },
}
